import React, { useMemo, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import GalleryWithMobileCarousel from '@justpark/ui/src/components/GalleryWithMobileCarousel';
import ThumbnailGallery from '@justpark/ui/src/components/ThumbnailGallery';
import AppBenefits from '../../components/Landing/AppBenefits';
import TopAttractions from '../../components/Landing/TopAttractions';
import Reviews from '../../components/Landing/Reviews';
import FaqBlock from '../../components/Landing/FaqBlock';
import WhatsNearby from '../../components/Landing/WhatsNearby';
import useLandingData from './useLandingData';
import imageResizer from '../../helpers/imageResizer';
import LandingHero from './LandingHero';
import LandingMeta from './LandingMeta';
import { page } from '../../helpers/Tracking/Analytics';

import styles from './landing.module.scss';

const cypress = 'landing';

const Landing = () => {
  useEffect(() => {
    page('landing');
  }, []);

  const landingData = useLandingData();
  const reviews = useLandingData()?.reviews;
  const featuredLocations = landingData?.featuredLocations;

  const isFaqsFullWidth = !featuredLocations || featuredLocations?.length < 15;

  const faqsFullWidthClass = isFaqsFullWidth ? styles.faqsFullWidth : '';

  const linkComponent = useCallback(
    (href, children) => <Link to={href}>{children}</Link>,
    []
  );

  const featuredLocationImagesData = landingData.featuredLocations;

  const featuredLocationImages = useMemo(
    () =>
      !!featuredLocationImagesData?.length &&
      featuredLocationImagesData.map((item) => ({
        ...item,
        url: imageResizer(item.url, {
          width: 350,
          height: 350
        }).src
      })),
    [featuredLocationImagesData]
  );

  const attractionsImagesData = landingData?.featuredAmenities;

  const attractionsImages = useMemo(
    () =>
      attractionsImagesData.map((item) => ({
        ...item,
        url: imageResizer(item.url, {
          width: 680,
          height: 640
        }).src
      })),
    [attractionsImagesData]
  );

  return (
    <div data-cy={cypress}>
      <LandingMeta />
      <LandingHero />

      {reviews && reviews.length > 3 && (
        <div className={styles.reviews}>
          <Reviews />
        </div>
      )}

      <div className={styles.benefits}>
        <AppBenefits />
      </div>
      <div className={`${styles.youNeedToKnow} ${faqsFullWidthClass}`}>
        <div className={styles.youNeedToKnowContainer}>
          {!isFaqsFullWidth && (
            <div className={styles.neighbourhoods}>
              <GalleryWithMobileCarousel
                images={featuredLocationImages}
                linkComponent={linkComponent}
              />
            </div>
          )}
          <div className={styles.faqs}>
            <FaqBlock
              heading={landingData.information.title}
              description={landingData.information.description}
              body={landingData.information.body}
              faqs={landingData.information.faqs}
              isSingleColumn={!isFaqsFullWidth}
            />
          </div>
        </div>
      </div>
      {landingData.amenities && attractionsImages?.length ? (
        <div className={styles.attractions}>
          <div
            className={styles.topAttractions}
            data-cy={`${cypress}-top-attractions`}
          >
            <TopAttractions
              heading={landingData.amenities.title}
              subHeading={landingData.amenities?.description}
              content={landingData.amenities.body}
            />
          </div>
          <div className={styles.amenities}>
            <ThumbnailGallery
              images={attractionsImages}
              linkComponent={linkComponent}
            />
          </div>
        </div>
      ) : (
        <div className={styles.whatsNearby}>
          <WhatsNearby
            description={landingData.whatsNearby.description}
            locations={landingData.whatsNearby.nearbyLocations}
            linkComponent={linkComponent}
          />
        </div>
      )}
      {/* <pre>{JSON.stringify(loaderData, undefined, 4)}</pre> */}
    </div>
  );
};
export default Landing;
